import { IAbstractRecord } from '@models';
import { enumListAsRecordObject } from '@utils/graph-utils';
import { ALL_OPTION, YEAR_KEY_PREFIX } from './content';

export const mapLookupsToLovs = (
  data: IAbstractRecord
): Record<string, Record<string, string>> => {
  const agency: Record<string, string> = {};
  (data?.Insurance?.queries?.allAgencies || []).forEach(
    (item: IAbstractRecord) => {
      agency[item.insurance_Agency_Id] = item.insurance_Agency_AgencyName;
    }
  );

  const rangeYear: Record<string, string> = {};
  (data?.Insurance?.queries?.exportAgencyVignetteRange || [])
    .map((item: IAbstractRecord) => item.insurance_AgencyVignetteRange_RangeYear)
    .filter((year: unknown) => year !== null && year !== undefined)
    .map((year: number | string) => String(year))
    .sort((a: string, b: string) => Number(b) - Number(a))
    .forEach((year: string) => {
      rangeYear[`${YEAR_KEY_PREFIX}${year}`] = year;
    });

  return {
    agency,
    rangeYear,
    rangeStatus: enumListAsRecordObject(
      data?.Insurance_VignetteRangeStatuses?.enumValues
    ),
  };
};

/**
 * "All" is exclusive: picking it drops the specific options, and picking a
 * specific option while "All" is selected drops "All".
 */
export const normalizeAllSelection = (
  previous: string[] = [],
  next: string[] = []
): string[] => {
  if (!next.includes(ALL_OPTION)) {
    return next;
  }
  if (!previous.includes(ALL_OPTION) || next.length === 1) {
    return [ALL_OPTION];
  }
  return next.filter((value) => value !== ALL_OPTION);
};

/** An empty list means "no filter" for the export query. */
export const toFilterValue = (selected: string[] | undefined): string[] => {
  const values = selected || [];
  return values.includes(ALL_OPTION) ? [] : values;
};

export const toYearFilterValue = (selected: string[] | undefined): number[] =>
  toFilterValue(selected).map((key) =>
    Number(key.replace(YEAR_KEY_PREFIX, ''))
  );

export const mapItemsToExcelData = (
  items: IAbstractRecord[],
  statuses: Record<string, string>
) =>
  items.map((item) => ({
    businessPartner: item.businessPartner_AgencyName,
    rangeYear: item.insurance_AgencyVignetteRange_RangeYear,
    rangeCode: item.insurance_AgencyVignetteRange_RangeCode,
    rangeFrom: item.insurance_AgencyVignetteRange_RangeFrom,
    rangeTo: item.insurance_AgencyVignetteRange_RangeTo,
    rangeStatus:
      statuses[item.insurance_AgencyVignetteRange_RangeStatus] ||
      item.insurance_AgencyVignetteRange_RangeStatus,
  }));
